import { initSlideshows } from "./modules/slideshows";
import { initViewModeToggle } from "./modules/view-mode";
import { initDownload } from "./modules/download";
import { initNewsletterCta } from "./modules/newsletter-cta";

initViewModeToggle();
initDownload();
initSlideshows();
initNewsletterCta();
